export enum Timespan {
  weekly='weekly',
  monthly='monthly',
  quarterly='quarterly',
  yearly='yearly',
}
